import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {SessionService} from './session.service';
import {MenuService} from './menu.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private sess: SessionService,
              private menuSvr: MenuService,
              private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.sess.isLoggedIn()) {
      return this.menuSvr.isValidUrl(state.url);
    }
    this.sess.setAttemptLink(state.url);
    return this.router.createUrlTree(['/login']);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }

}
